import React, { useMemo } from "react";
import {
  SFHeroCard,
  SFHeroTile,
  SFDetailTile,
  SFClientSideFilterActions,
} from "@sf-core";
import _ from "lodash";
import { Logger } from "@base-provider";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { GRID_NAMES } from "../../../../constants/gridNames";

const BelowTargetCard = ({ skills, actions }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const state = "negative";
  const type = "set";

  const savedLayout = useSelector((state) => {
    return state.clientSideFilter.find(
      (clientSideFilter) =>
        clientSideFilter.gridName === GRID_NAMES.DASHBOARD_MY_SKILLS
    );
  });

  const belowTargetNumber = useMemo(() => {
    let count = _.filter(
      skills,
      (skill) => skill.proficiencyLevel < skill.proficiencyLevelTarget
    ).length;
    return count;
  }, [skills]);

  const onClick = () => {
    let currentFilterModel = savedLayout?.state?.filter?.filterModel || [];
    const payload = {
      gridName: GRID_NAMES.DASHBOARD_MY_SKILLS,
      state: {
        filter: {
          filterModel: {
            ...currentFilterModel,
            isBelowTarget: {
              type: type,
              values: ["true"],
            },
          },
        },
      },
    };
    dispatch(SFClientSideFilterActions.saveState(payload));
  };

  Logger.of("App.BelowTargetCard").info(belowTargetNumber);

  return (
    <SFHeroCard
      actions={actions}
      leftContent={
        <SFHeroTile
          title={belowTargetNumber}
          subTitle={t("dashboardScreen.belowTargetCard.title")}
          state={state}
        />
      }
    >
      <div onClick={() => onClick()}>
        <SFDetailTile
          title={t("dashboardScreen.belowTargetCard.detail.title")}
          subTitle={
            belowTargetNumber > 0
              ? t("dashboardScreen.belowTargetCard.detail.subTitle")
              : t("dashboardScreen.belowTargetCard.detail.subTitleNoBelow")
          }
        />
      </div>
    </SFHeroCard>
  );
};

export default BelowTargetCard;
